module.exports = __webpack_public_path__ + "static/person-bubble-2-c17841f378017bd715614a7622714a06.png";